export default __webpack_public_path__ + "static/journey-integration-ebb0cab8e3078680d32db6ab0fece448.jpg";